import { t } from 'i18next';
import * as yup from 'yup';

import { ContactGroupType } from 'contacts/enums';
import { testRequiredSchema } from 'core/schemas';

import { TRequiredFields } from './types';

export const mergeLocationsSchema = (
  contactGroupTypes: ContactGroupType[] = [],
  requiredFields: TRequiredFields
) =>
  yup.object({
    name: yup
      .object({
        id: yup.number().label(t('labelLocationName')).required(),
        value: yup.string().nullable(),
      })
      .label(t('labelLocationName'))
      .nullable()
      .test(...testRequiredSchema(requiredFields?.name, t('labelLocationName'))),
    address: yup
      .object({
        id: yup.number().label(t('labelAddress')).required(),
        value: yup.object().nullable(),
      })
      .label(t('labelAddress'))
      .nullable()
      .test(...testRequiredSchema(requiredFields?.address, t('labelAddress'))),
    ...(contactGroupTypes.includes(ContactGroupType.CUSTOMER)
      ? {
          externalCustomerNumber: yup
            .object({
              id: yup.number().label(t('labelCustomerNumber')).required(),
              value: yup.string().nullable(),
            })
            .label(t('labelCustomerNumber'))
            .nullable()
            .test(
              ...testRequiredSchema(
                requiredFields?.externalCustomerNumber,
                t('labelCustomerNumber')
              )
            ),
          accountsReceivableId: yup
            .object({
              id: yup.number().label(t('labelARNumber')).required(),
              value: yup.string().nullable(),
            })
            .label(t('labelARNumber'))
            .nullable()
            .test(...testRequiredSchema(requiredFields?.accountsReceivableId, t('labelARNumber'))),
          isShipTo: yup.boolean().label(t('labelShipTo')).required(),
          isBillTo: yup.boolean().label(t('labelBillTo')).required(),
        }
      : {}),
    ...(contactGroupTypes.includes(ContactGroupType.VENDOR)
      ? {
          accountsPayableId: yup
            .object({
              id: yup.number().label(t('labelAPNumber')).required(),
              value: yup.string().nullable(),
            })
            .label(t('labelAPNumber'))
            .nullable()
            .test(...testRequiredSchema(requiredFields?.accountsPayableId, t('labelAPNumber'))),
        }
      : {}),
  });
